import { ResponseDataTest } from "../../../models/responseDataTest";
import { agroApi } from "../api";
import { ResponseDataGet } from "../../../models/responseDataGet";
import { EntDirectoryInfoName } from "../../../models/directoryInfoName";
import { EntInitialFilterName } from "../../../models/filters/initialFilterName";
import { Paths } from "../../../paths";

export const leasingProjectApi = agroApi.injectEndpoints({
    endpoints: (builder) => ({
        getLeasingProjectList: builder.query<ResponseDataGet<EntDirectoryInfoName>, EntInitialFilterName>({
            query: (filter) => ({
                url: `${Paths.handbooks.leasingproject}/get-all`,
                method: "POST",
                body: JSON.stringify(filter)
            }),
        }),
        getLeasingProjectById: builder.query<ResponseDataTest<EntDirectoryInfoName>, number>({
            query: (id) => ({
                url: `${Paths.handbooks.leasingproject}/${id}`,
                method: 'GET'
            })
        }),
        addLeasingProject: builder.mutation<ResponseDataTest<EntDirectoryInfoName>, EntDirectoryInfoName>({
            query: (body) => ({
                url: `${Paths.handbooks.leasingproject}`,
                method: "POST",
                body: JSON.stringify(body)
            }),
        }),
        editLeasingProject: builder.mutation<ResponseDataTest<EntDirectoryInfoName>, EntDirectoryInfoName>({
            query: (body, ) => ({
                url: `${Paths.handbooks.leasingproject}`,
                method: 'PUT',
                body: JSON.stringify(body),
            }),
        }),
        deleteLeasingProject: builder.mutation<ResponseDataTest<EntDirectoryInfoName>, number>({
            query: (id) => ({
                url: `${Paths.handbooks.leasingproject}/${id}`,
                method: 'DELETE',
            }),
        }),
    }),
    overrideExisting: false,
});

export const {
    useAddLeasingProjectMutation,
    useDeleteLeasingProjectMutation,
    useEditLeasingProjectMutation,
    useLazyGetLeasingProjectListQuery
} = leasingProjectApi;
